import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/hooks/stores/useAuth';
import logo from '../assets/images/logo.png';
import { VIDEO_URLS } from '../config/constants';

export function VideoPopup() {
    const navigate = useNavigate();
    const { userRole } = useAuth();
    const [videoEnded, setVideoEnded] = useState(false);

    useEffect(() => {
      // Load Vimeo Player API script
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        // Initialize Vimeo player
        const player = new window.Vimeo.Player(document.querySelector('iframe'));
        
        // Listen for video end event
        player.on('ended', () => {
          setVideoEnded(true);
        });
      };

      return () => {
        document.body.removeChild(script);
      };
    }, []);

  return (
    <div className="fixed inset-0 flex items-center bg-[#F1EBDB] justify-center p-4 md:p-6 md:pt-20">
      <div className="flex flex-col items-center bg-[#F1EBDB] p-4 md:p-6 rounded-lg shadow-lg w-full max-w-[95%] md:max-w-[65%]">
        {userRole?.toLowerCase() !== 'user' && (
          <img 
            src={logo} 
            alt="PostScrypt Logo" 
            className="h-14 md:h-16 mb-4 md:mb-6"
          />
        )}
        <div className="w-full aspect-video">
          <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
            <iframe
              src={`${VIDEO_URLS.INTRO_VIDEO}&autoplay=1`}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              className="rounded-lg"
              title="PostScrypt Introduction"
            />
          </div>
        </div>
        <button
          onClick={() => {
            if (userRole?.toLowerCase() === 'user') {
              navigate('/');
            } else {
              navigate('/initial-questionnaire');
            }
          }}
          disabled={!videoEnded}
          className={`mt-4 md:mt-6 px-6 md:px-8 py-2 md:py-3 rounded-full transition-colors font-medium
            ${videoEnded 
              ? 'bg-[#F16745] text-white hover:bg-[#F16745] cursor-pointer' 
              : 'bg-gray-400 text-gray-200 cursor-not-allowed'}`}
        >
          {videoEnded ? 'Continue' : 'Please watch the video'}
        </button>
      </div>
    </div>
  );
} 